import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { toast } from "react-toastify";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function MultipleUploadFile({ setFieldValue, name, error, touched, calitateaDetinatorului, id }) {
   const MAX_COUNT = 5;
   const supportedFormats = ["application/pdf", "image/png", "image/jpg", "image/jpeg"];
   const [uploadedFiles, setUploadedFiles] = useState([]);
   const [fileLimit, setFileLimit] = useState(false);

   const handleUploadFiles = files => {
      const uploaded = [...uploadedFiles];
      setFieldValue(name, uploaded);
      let limitExceeded = false;
      files.some(file => {
         if (!supportedFormats.includes(file.type)) {
            toast.error("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)");
            return true;
         }
         if (file.size > 5000000) {
            toast.error("Un fișier nu poate avea mai mult de 5MB.");
            return true;
         }
         if (uploaded.findIndex(f => f.name === file.name) === -1) {
            uploaded.push(file);
            if (uploaded.length === MAX_COUNT) setFileLimit(true);
            if (uploaded.length > MAX_COUNT) {
               toast.error(`Poti incarca maximul de ${MAX_COUNT} fisiere.`);
               setFileLimit(false);
               limitExceeded = true;
               return true;
            }
         }
      });
      if (!limitExceeded) setUploadedFiles(uploaded);
   };

   const handleFileEvent = e => {
      const chosenFiles = Array.prototype.slice.call(e.target.files);
      handleUploadFiles(chosenFiles);
   };

   const handleRemoveFile = file => {
      const uploaded = [...uploadedFiles];
      const index = uploaded.findIndex(f => f.name === file.name);
      uploaded.splice(index, 1);
      setUploadedFiles(uploaded);
      setFieldValue(name, uploaded);
      if (uploaded.length < MAX_COUNT) setFileLimit(false);
   };

   return (
      <>
         <label id={id} htmlFor="multipleFileUpload" className="cursor-pointer">
            <input
               className="hidden"
               id="multipleFileUpload"
               type="file"
               multiple
               accept="application/pdf, image/png, image/jpeg, image/jpg"
               onChange={handleFileEvent}
               disabled={fileLimit}
            />
            <img src={require("assets/images/upload.png")} />
         </label>
         {/*          <p className="contr-sub text-center font-size-18 mt-30">{calitateaDetinatorului && `Documente ${calitateaDetinatorului}`}</p> */}
         <p className="text-up margin-top-10">Încarcă documentul *pdf, png, jpg, jpeg</p>
         <div className="row">
            {uploadedFiles.map((file, index) => (
               <div className="col-4" key={index}>
                  {file.name.split(".").pop() === "pdf" ? (
                     <div>
                        <Document file={file}>
                           <Page pageNumber={1} />
                        </Document>
                        <div className="overflow">{file.name}</div>
                        <button type="button" className="delete-button-compact" onClick={() => handleRemoveFile(file)}>
                           Șterge
                        </button>
                     </div>
                  ) : file.name.split(".").pop() === "png" || file.name.split(".").pop() === "jpg" || file.name.split(".").pop() === "jpeg" ? (
                     <div>
                        <img className="ss-prew-compact" src={URL.createObjectURL(file)} alt={file.name} />
                        <div className="overflow">{file.name}</div>
                        <button type="button" className="delete-button-compact" onClick={() => handleRemoveFile(file)}>
                           Șterge
                        </button>
                     </div>
                  ) : null}
               </div>
            ))}
         </div>
         {error && touched && <div className="text-center error-msg">{error}</div>}
      </>
   );
}
